import { ChevronDown, Download, ListVideo } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useStore } from "@/lib/store";
import ReminderMenu from "@/components/ReminderMenu";

export default function TitleBar({ onManage }) {
  const { accounts, active, setActive, installEvt, clearInstall } = useStore();
  return (
    <header className="h-12 shrink-0 flex items-center gap-3 px-4 border-b border-[#212738] bg-[#08090E]/90 backdrop-blur-md" data-testid="title-bar">
      <img src="/icon-192.png" alt="" className="w-6 h-6 rounded-md" />
      <span className="font-heading font-bold tracking-tight">XC Player</span>
      <span className="xc-label hidden sm:inline">Xtream Codes</span>
      <div className="flex-1" />
      {installEvt && (
        <button
          onClick={async () => {
            installEvt.prompt();
            await installEvt.userChoice;
            clearInstall();
          }}
          className="xc-btn-ghost !py-1.5 text-xs"
          data-testid="install-app-button"
        >
          <Download className="w-3.5 h-3.5" /> Install app
        </button>
      )}
      <ReminderMenu />
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-2 rounded-lg border border-[#212738] px-3 py-1.5 text-sm hover:border-[#38425C]" data-testid="account-switcher">
          <span className="w-2 h-2 rounded-full bg-[#10B981]" />
          <span className="max-w-[160px] truncate">{active?.name}</span>
          <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#11141F] border-[#212738] text-slate-200 min-w-[220px]">
          {accounts.map((a) => (
            <DropdownMenuItem key={a.id} onClick={() => setActive(a.id)} className="focus:bg-[#1A1E2E] focus:text-white" data-testid={`switch-account-${a.id}`}>
              {a.name}
            </DropdownMenuItem>
          ))}
          <DropdownMenuSeparator className="bg-[#212738]" />
          <DropdownMenuItem onClick={onManage} className="focus:bg-[#1A1E2E] focus:text-white" data-testid="manage-accounts-button">
            <ListVideo className="w-4 h-4 mr-2" /> Manage playlists
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
